import { getUserFromLocalStorage } from "@/helpers/userHelper";
import { getSelectedPrincipal } from "@/helpers/principalHelper";

export default {
  module: { name: "EO.DASHBOARD" },
  modules: [],
  allModules: [],
  users: [],
  globalEoConfig: {},
  groups: [],
  oAuthClients: [],
  thirdPartySystems: [],
  cities: [],
  mappingFields: [],
  session: getUserFromLocalStorage(),
  selectedPrincipal: getSelectedPrincipal(),
  featureGroups: [],
  featureGroupsForEvents: [],
  featureGroupsForNews: [],
  globalFeatureGroups: [],
  currentUser: null,
  principals: [],
  apiKeys: [],
  newsApiKeys: [],
  eventsApiKeys: [],
  kisApiKeys: [],
  adManagerApiKeys: [],
  llmApiKeys: [],
  principalList: [],
  categoriesById: {},
  categories: [],
  categoryGroups: [],
  categoryGroupsById: {},
  categoryTypes: [],
  categoryTypesById: {},
  exportConfigs: [],
  exportConfigsTotal: 0,
  prev: "/",
  snackbar: false,
  snackbarColor: "",
  snackbarText: "",
  navbarExpanded: false,
  globalConfig: {
    showWinterSeason: false,
    showPricesCosts: false,
    currentSeason: "",
    summerSeasonRange: ["", ""],
    export: {
      seasonFeatures: {
        summer: "",
        winter: ""
      }
    },
    address: {
      name: "",
      address: "",
      additionalAddress: "",
      zip: "",
      city: "",
      district: "",
      country: "",
      phoneNumber: "",
      mobileNumber: "",
      eMail: "",
      website: ""
    },
    tileServer: {
      url: "",
      params: "",
      attribution: ""
    },
    apiKeys: [
      {
        apiKey: "",
        description: "",
        searchFilterUiElements: {
          excludedCategories: [],
          includedCategories: [],
          includedFeatures: [],
          excludedFeatures: []
        }
      }
    ],
    favoriteFeatures: []
  },
  roleCategories: [],
  eventStatistics: {},
  events: [],
  externEvents: [],
  externEventCount: 0,
  allExternEventIds: [],
  eventCount: 0,
  organizer: [],
  organizerById: {},
  locations: [],
  locationsById: {},
  oplocs: [],
  oplocCount: 0,
  organizerLoading: false,
  organizerCities: [],
  categoryGroupsForEvents: [],
  eventConfig: {
    address: {
      name: "",
      address: "",
      additionalAddress: "",
      zip: "",
      city: "",
      district: "",
      country: "",
      phoneNumber: "",
      mobileNumber: "",
      eMail: "",
      website: ""
    },
    tileServer: {
      url: "",
      params: "",
      attribution: ""
    },
    useHighlightFrom: "standard"
  },
  newsConfig: {},
  llmConfig: {},
  adManagerConfig: {},
  autocompleteNews: [],
  relatedNews: [],
  issues: [],
  newsFeatureGroups: [],
  newsFeatures: [],
  newsArticleTypes: [],
  newsAppContentTypes: [],
  eventsAppContentTypes: [],
  momentsForEvent: [],
  poiStatistics: {},
  regions: [],
  regionPois: [],
  holidays: [],
  vacations: [],
  departmentCount: 0,
  departments: [],
  personCount: 0,
  persons: [],
  facilityCount: 0,
  facilities: [],
  taskCount: 0,
  tasks: [],
  relatedTasks: [],
  autocompleteTasks: [],
  subjectAreaCount: 0,
  subjectAreas: [],
  committeeCount: 0,
  committees: [],
  clubCount: 0,
  clubs: [],
  defects: [],
  defectStatistics: {},
  defectCount: 0,
  defectCategories: [],
  servicePackages: [],
  servicePackageCount: 0,
  accommodationTypeCount: 0,
  accommodationTypes: [],
  bookingFeatureGroups: [],
  mapsConfig: {},
  mapsApiKeys: []
};
